import React, { PureComponent } from 'react'
import Loadable from 'react-loadable';
import FourOFour from '../error/FourOFour';
import Loader from '../../widgets/loading/Loader';
import ToolScreen from './ToolScreen';

const Img2Brs = Loadable({
  loader: () => import(/* webpackChunkName: "img2brs" */ '../../tools/img2brs/Img2Brs'),
  loading: Loader
});

const BrickGenerator = Loadable({
  loader: () => import(/* webpackChunkName: "brickgen" */ '../../tools/brickGen/BrickGenerator'),
  loading: Loader
});

const Brs2Json = Loadable({
  loader: () => import(/* webpackChunkName: "brs2json" */ '../../tools/brs2json/Brs2Json'),
  loading: Loader
});

const Json2Brs = Loadable({
  loader: () => import(/* webpackChunkName: "json2brs" */ '../../tools/json2brs/Json2Brs'),
  loading: Loader
});

const Version = Loadable({
  loader: () => import(/* webpackChunkName: "version" */ '../../tools/version/Version'),
  loading: Loader
});

const Mirror = Loadable({
  loader: () => import(/* webpackChunkName: "mirror" */ '../../tools/mirror/Mirror'),
  loading: Loader
});

const Resize = Loadable({
  loader: () => import(/* webpackChunkName: "resize" */ '../../tools/resize/Resize'),
  loading: Loader
});

const Plate = Loadable({
  loader: () => import(/* webpackChunkName: "plate" */ '../../tools/plate/Plate'),
  loading: Loader
});

const ColorList = Loadable({
  loader: () => import(/* webpackChunkName: "colorlist" */ '../../tools/colorList/ColorList'),
  loading: Loader
});

const Spyware = Loadable({
  loader: () => import(/* webpackChunkName: "spyware" */ '../../tools/spyware/Spyware'),
  loading: Loader
});

const Material = Loadable({
  loader: () => import(/* webpackChunkName: "material" */ '../../tools/material/Material'),
  loading: Loader
});

const Modify = Loadable({
  loader: () => import(/* webpackChunkName: "material" */ '../../tools/modify/Modify'),
  loading: Loader
});

class Tools extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      component: this.props.match && this.props.match.params && this.props.match.params.toolName ? Loader : ToolScreen
    }
  }

  componentDidMount() {
    this.loadComponent();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.match && this.props.match.params && this.props.match.params.toolName) !== (prevProps.match && prevProps.match.params && prevProps.match.params.toolName)) {
      this.loadComponent();
    }
  }

  getComponent() {
    if (this.props.match && this.props.match.params && this.props.match.params.toolName) {
      switch(this.props.match.params.toolName) {
        case('img2brs'):
          return Img2Brs
        case('brickgen'):
          return BrickGenerator
        case('brs2json'):
          return Brs2Json
        case('json2brs'):
          return Json2Brs
        case('a4izer'):
          return Version
        case('mirror'):
          return Mirror
        case('resize'):
          return Resize
        case('plate'):
          return Plate
        case('colors'):
          return ColorList
        case('spyware'):
          return Spyware
        case('material'):
          return Material
        case('modify'):
          return Modify
        default:
          return FourOFour
      }
    }

    return ToolScreen;
  }

  loadComponent() {
    this.setState({
      component: this.getComponent()
    })
  }

  render() {
    const ToolComponent = this.state.component;
    return (
      <ToolComponent />
    )
  }
}

export default Tools